import { type TeamMemberRole, type TeamMemberStatus } from '../store/sageHomeApi';

export const TeamRoles: Record<string, TeamMemberRole> = {
    CareRecipient: 'CARE_RECIPIENT',
    CommunityCaregiver: 'COMMUNITY_CAREGIVER',
    LicensedCaregiver: 'LICENSED_CAREGIVER',
    TeamAdmin: 'TEAM_ADMIN',
} as const;

export const TeamRoleDisplayNames: Record<string, string> = {
    [TeamRoles.CareRecipient]: 'Care Recipient',
    [TeamRoles.CommunityCaregiver]: 'Friends & Family Caregiver',
    [TeamRoles.LicensedCaregiver]: 'Licensed Caregiver',
    [TeamRoles.TeamAdmin]: 'Team Admin',
} as const;

export const TeamMemberStatuses: Record<string, TeamMemberStatus> = {
    Active: 'ACTIVE',
    Invited: 'INVITED',
} as const;
